






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SubNavigation extends Vue {
    @Prop({ default: false }) readonly fullWidth!: boolean

    get componentClasses(): object {
        return {
            'new-navigation-submenu': true,
            'new-navigation-submenu--full-width': this.fullWidth,
        }
    }
}

